import { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import {
  customName,
  getColorFromId,
  getColorFromEmail,
} from "../../helpers/commonHelpers";

const RemoveAttendeesModalNew = (props) => {
  const { attendee, meetingData } = props;
  const handleSubmit = () => {
    props.handleSubmit();
  };
  const isMeetingOrganiser =
    meetingData?.createdById?.toString() === attendee?._id?.toString()
      ? true
      : false;
     
  return (
    <>
      <Modal
        show={props.isModalOpen}
        onHide={(e) => props.setIsModalOpen(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Attendee</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="attendees-popup">
            <div className="attendee-content">
              
              <div
                className="attendee attendee-list sl attendee-list-circle"
                style={{
                  backgroundColor: attendee?.profilePicture
                    ? undefined
                    : attendee._id
                      ? getColorFromId(attendee._id)
                      : getColorFromEmail(attendee.email),
                
                }}
              >
                {attendee?.profilePicture ? (
                  <img
                    src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                    alt=""
                    className="attendee-profile-picture icon-image attendee-list-circle-img"
                    style={{
                      // width: "35px",
                      // height: "35px",
                      // borderRadius: "50%",
                      // objectFit: "cover",
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = "none";
                       e.target.parentElement.style.backgroundColor =
                                                                    getColorFromId(attendee?._id);
                                                                  e.target.parentElement.innerText =
                                                                    customName(attendee?.name);
                    }}
                  />
                ) : (
                  <span className="attendee-name">
                    {customName(attendee.name)}
                  </span>
                )}
              </div>

              <div className="action-cmnt-text">
                <p className="detail-name word-break">{attendee?.name}</p>
                <p className="name-undertext detail-date-time comment-text">
                  {attendee?.email}{" "}
                  {attendee?.isEmployee === false && "(Guest)"}
                </p>
              </div>
            </div>
            {props.allowRemove ? (
              <div className="action-cmnt-text">
                <p> {props.message}</p>
              </div>
            ) : null}
          </div>
        </Modal.Body>
        {props.allowRemove ? (
          <Modal.Footer>
            <Button
              variant=""
              onClick={(e) => props.setIsModalOpen(false)}
              className="add-btn Mom-btn"
            >
              <p>No</p>
            </Button>
            <Button
              variant=""
              onClick={handleSubmit}
              className="create-meeting-button Mom-btn"
            >
              <p>Yes</p>
            </Button>
          </Modal.Footer>
        ) : null}
      </Modal>
    </>
  );
};

export default RemoveAttendeesModalNew;
